import axios from 'axios';

const environment = {
  local: {
    api: 'http://localhost:3333/dashboard',
  },
  homolog: {
    api: process.env.REACT_APP_BASE_API_HOMOLOG as string,
  },
  production: {
    api: 'https://cooperfibra-armazem-api.webcol.systems/dashboard',
  },
};

export const baseURL =
  process.env.NODE_ENV === 'development'
    ? environment.local
    : environment.production;

export const showProductionApiAlert =
  process.env.NODE_ENV === 'development' && baseURL === environment.production;

export const api = axios.create({
  baseURL: baseURL.api,
  headers: {},
});

// Simple 401 interceptor setup
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check for 401 Unauthorized OR 501 (could be related to auth)
    if (error.response?.status === 401 || error.response?.status === 501) {
      if (!window.location.href.includes("login")) {
        console.log(`${error.response.status} detected - redirecting to login`);
        // Clear any stored authentication data
        localStorage.removeItem('persist:cooperfibra-armzem.v.0.3');
        // Force redirect to login
        window.location.href = '/login';
      }

      return Promise.reject(error)
    }

    return Promise.reject(error);
  }
);

export const applyQueryString = (
  url: string,
  payload: Record<string, any>
): string => {
  const validObject: Record<string, any> = {};

  delete payload.dirty;

  for (const [param, value] of Object.entries(payload)) {
    if (value) Object.assign(validObject, { [param]: value });
  }

  if (Object.keys(validObject).length === 0) {
    return url;
  }

  const searchParams = new URLSearchParams(validObject).toString();

  return `${url}?${searchParams}`;
};

export const formDataBuilder = (payload: Record<string, any>): FormData => {
  const formData = new FormData();

  for (const [param, value] of Object.entries(payload)) {
    if (value instanceof File) {
      formData.append(param, value, value.name);
    } else if (value instanceof FileList) {
      for (let i = 0; i < value.length; i++) {
        formData.append(`${param}[]`, value[i], value[i].name);
      }
    } else if (value) {
      formData.append(param, value);
    }
  }

  return formData;
};
